import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import Pagination from './Pagination';
import classes from "./PostList.module.scss";
import { PageTitle } from "../PageTitle/PageTitle";

interface Post {
  id: number;
  title: { rendered: string };
  excerpt: { rendered: string };
  link: string;
  featured_media_url?: string;
}

const NewsList: React.FC<{ categoryId: number; limit: number }> = ({ categoryId, limit }) => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPosts, setTotalPosts] = useState(0);
  const location = useLocation();
  const pageTitle = getPageTitle(location.pathname);
  const langCode = location.pathname.split('/')[1] || 'ja'; // URLから言語コードを取得 (デフォルトは 'ja')

  const stripHtml = (html: string) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const limitText = (text: string, limit: number) => {
    const plainText = stripHtml(text);
    return plainText.length > limit ? plainText.substring(0, limit) + "..." : plainText;
  };

  useEffect(() => {
    const fetchPosts = async () => {
      const url = `https://hado-official.com/wp-json/wp/v2/posts?_embed&categories=${categoryId}&per_page=${limit}&page=${currentPage}`;
      const response = await fetch(url);
      const total = response.headers.get('X-WP-Total') || '0';

      setTotalPosts(parseInt(total, 10));
      const data = await response.json();

      setPosts(data.map((post: any) => ({
        ...post,
        featured_media_url: post._embedded?.['wp:featuredmedia']?.[0]?.source_url,
      })));
    };

    document.title = pageTitle;
    fetchPosts().catch(err => console.error('Error fetching data:', err));
  }, [categoryId, currentPage, limit, pageTitle]);

  return (
    <div className={classes.root + ' contents'}>
      <PageTitle className={classes.pageTitle} title={pageTitle} />
      <ul className={classes.newsList + ' contentWidth'}>
        {posts.map((post, index) => (
          <li key={index} className={classes.newsItem}>
            <Link to={`/${langCode}/post/${post.id}`}>
              {post.featured_media_url && <img src={post.featured_media_url} alt={post.title.rendered} className={classes.newsItemImg} />}
              <h2 className={classes.newsItemTitle}>{limitText(post.title.rendered, 30)}</h2>
              <div className={classes.newsItemText}>{limitText(post.excerpt.rendered, 50)}</div>
            </Link>
          </li>
        ))}
      </ul>
      <Pagination totalPosts={totalPosts} postsPerPage={limit} currentPage={currentPage} setCurrentPage={setCurrentPage} />
    </div>
  );
};

const getPageTitle = (path: string) => {
  switch (path) {
    case '/ja/news': return 'NEWS';
    case '/ja/interviews': return '導入校インタビュー';
    case '/en/news': return 'NEWS';
    case '/en/interviews': return 'School Interviews';
    default: return '';
  }
};

export default NewsList;
